<template>
  <form>
    <v-row class="py-0">
      <v-col class="py-0" cols="12" sm="12" md="11" lg="11">
        <form-edit :form="pph" :listInvoice="listInvoice" ref="formEdit" v-if="!edit"></form-edit>
        <detail :form="pph" v-if="edit"></detail>
      </v-col>
      <v-col cols="12" sm="12" md="1">
        <v-row class="py-0 mb-2" v-if="!edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="$rbac.can('pph-4-verse-2.update')"
                  color="success"
                  v-on="on"
                  @click="updateItem"
                >
                  <v-icon>
                    mdi-content-save
                  </v-icon>
                </v-btn>
              </template>
              <span>Save</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="$rbac.can('pph-4-verse-2.update')"
                  color="success"
                  v-on="on"
                  @click="editItem"
                >
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="$rbac.can('pph-4-verse-2.delete')"
                  color="error"
                  v-on="on"
                  @click.stop="deleteDialog"
                >
                  <v-icon>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="!edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="error" v-on="on" @click="cancel">
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
              <span>Close</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" v-on="on" @click="back">
                  <v-icon>
                    mdi-arrow-left
                  </v-icon>
                </v-btn>
              </template>
              <span>Back</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="blue-grey" dark v-on="on" @click="dialogAuditHistory = true">
                  <v-icon>mdi-history</v-icon>
                </v-btn>
              </template>
              <span>History</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialog-delete
      :id="id"
      :dialog="dialog"
      :invoiceNumber="pph.number"
      title="PPH 4 Verse 2"
      @deleteItem="deleteItem"
      @close="close"
    ></dialog-delete>
    <dialog-audit-history
      :dialog="dialogAuditHistory"
      entity-type="TaxPph4Verse2"
      :entity-id="id"
      @close="dialogAuditHistory = false"
    ></dialog-audit-history>
  </form>
</template>

<script>
import Detail from "./DetailTaxPph4Verse2";
import FormEdit from "./FormTaxPph4Verse2";
import DialogDelete from "@/components/DialogDelete";
import DialogAuditHistory from "@/components/DialogAuditHistory.vue";
import { mapState } from "vuex";

export default {
  name: "pph-4-verse-2-view",
  components: {
    Detail,
    "form-edit": FormEdit,
    "dialog-delete": DialogDelete,
    "dialog-audit-history": DialogAuditHistory,
  },
  props: {
    id: Number,
  },
  data: () => ({
    edit: true,
    dialog: false,
    dialogAuditHistory: false,
    pph: {},
  }),
  computed: {
    ...mapState("pph", ["listInvoice"]),
  },
  methods: {
    async getPph4Verse2() {
      await this.$store.dispatch("pph/getPph4Verse2ById", this.id).then(response => {
        this.pph = response.data;
      });
    },
    back() {
      this.$router.go(-1);
    },
    editItem() {
      this.edit = false;
    },
    updateItem() {
      this.$refs.formEdit.submit();
    },
    async deleteItem(id) {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("pph/deletePph4Verse2", id)
        .then(() => {
          this.dialog = false;
          this.$router.push({ name: "PPH 4 Verse 2" });
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    deleteDialog() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    cancel() {
      this.getPph4Verse2();
      this.edit = true;
    },
    async getInitialData() {
      this.$store.commit("SET_LOADER", true);
      Promise.all([await this.$store.dispatch("pph/getSaleInvoice"), this.getPph4Verse2()])
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },
  mounted() {
    this.getInitialData();
  },
};
</script>

<style></style>
